<template>
  <div class="card">
    <div class="content" :class="getOtherClass()">
      <div class="summaryText" ref="textHeight">{{ data.content }}</div>
      <div
        class="summaryImgList"
        v-if="data.attachmentVos && data.attachmentVos.length"
      >
        <img
          v-for="img in data.attachmentVos"
          :key="img.id"
          :src="img.url"
          alt=""
          class="summaryImg"
          @click="showSummaryImage(img.url)"
        />
      </div>
    </div>
    <div v-if="isShow" class="footer" @click="change()">
      <img
        :src="
          isHide
            ? require('@/assets/images/show_icon.png')
            : require('@/assets/images/hide_icon.png')
        "
        alt=""
      />
      <div class="footerText">
        {{ isHide ? $t('展开查看全部内容') : $t('收起') }}
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Field } from 'vant'
Vue.use(Field)
export default {
  name: 'Summary',
  props: ['summaryInfo', 'click'],
  data() {
    return {
      data: this.summaryInfo,
      isShow: false,
      isHide: true,
    }
  },
  computed: {},
  methods: {
    showSummaryImage(url) {
      if (this.click) this.click(url)
    },
    change() {
      this.isHide = !this.isHide
      this.getOtherClass()
    },
    getHeight() {
      const height = this.$refs.textHeight.offsetHeight
      if (
        height > 65 ||
        (this.data.attachmentVos && this.data.attachmentVos.length)
      ) {
        this.isShow = true
        this.isHide = true
      }
    },
    getOtherClass() {
      if (this.isShow && this.isHide) {
        let className = 'hideStyle'
        return className
      } else {
        return
      }
    },
  },
  mounted() {
    this.getHeight()
  },
}
</script>
<style lang="less" scoped>
.card {
  width: 100%;
}
.content {
  margin-bottom: 9px;
}
.summaryText {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: #5e5e5e;
  white-space: pre-wrap;
  word-break: break-all;
}
.summaryImgList {
  display: flex;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 9px;
}
.summaryImg {
  width: 80px;
  height: 80px;
  margin-right: 7px;
}
.footer {
  width: 100%;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  .footerText {
    font-size: 11px;
    font-weight: 400;
    color: #aaaaab;
    line-height: 16px;
  }
}
.hideStyle {
  height: 65px;
  overflow: hidden;
}
</style>
